import { useMutation, useQueryClient } from '@tanstack/react-query';
import { putAgentAvailabileService, putAgentAvailabileStatusById } from '../../api/AgentCenterAPI';
import { queryKeys } from '../queryKeys';
import { toast } from 'react-toastify';
import { AxiosError } from 'axios';

export const useUpdateAgentAvailabileService = () => {
    const {
        mutateAsync: updateAgentAvailabileService,
        isPending,
        ...rest
    } = useMutation({
        mutationFn: putAgentAvailabileService,
    });

    return { updateAgentAvailabileService, isPending, ...rest };
};

export const useUpdateAgentAvailabileStatusById = () => {
    const queryClient = useQueryClient();
    const {
        mutate: updateAgentAvailabileStatusById,
        isPending,
        ...rest
    } = useMutation({
        mutationFn: putAgentAvailabileStatusById,
        retry: false,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.managerCenterData });
        },
        onError: (error) => {
            const errorMessage =
                (error as AxiosError<{ message: string }>).response?.data.message ||
                'Error updating agent availability';
            toast.error(errorMessage);
        },
    });

    return { updateAgentAvailabileStatusById, isPending, ...rest };
};
